const OrderSummary = ({ order, formatCurrency }) => (
    <div className="mt-8 p-5 border rounded-lg shadow-md bg-gray-50">
      <h3 className="text-xl font-semibold text-secondary mb-4">Order Summary</h3>
      <div className="space-y-2">
        <div className="flex justify-between">
          <span>Subtotal (Items):</span>
          <span>${order?.items?.reduce((acc, curr) => acc + (Number(curr.initialPrice) * curr.quantity), 0).toFixed(2)}</span>
        </div>
        {/* <div className="flex justify-between">
          <span>Attribute Adjustments:</span>
          <span>${formatCurrency(order.items.reduce((sum, item) => sum + item.attributes.reduce((attrSum, attr) => attrSum + Number(attr.price || 0), 0) * item.quantity, 0))}</span>
        </div> */}
        <div className="flex justify-between">
          <span>Taxes:</span>
          <span>${order?.items?.reduce((acc, item) => acc + item.taxes.reduce((taxAcc, tax) => taxAcc + tax.taxAmount, 0), 0).toFixed(2)}</span>
        </div>
        <div className="border-t border-gray-300 my-2 pt-2 flex justify-between font-bold text-lg">
          <span>Total:</span>
          <span className="text-primary">${order?.totalAmount}</span>
        </div>
      </div>
    </div>
  );
  export default OrderSummary